import styled from "styled-components";

export const Photo = styled.img`
  max-width: 100%;
  height: auto;
`;
